import React, { useState, useContext, useRef, useCallback, useEffect } from "react";
import PATHS from "../../../Routes/paths";

import { ChartLegend } from "../../../Components/Atoms";
import { ModelPicker } from "../../../Components/Molecules";
import { Stack } from "../../../Components/Organisms/Graphs";
import { Report } from "../../../Templates";

import { getStatsData, getWidgetData } from "../../../APIs";
import { StoreContext } from "../../../Library/contexts";
import { DATE_RANGES } from "../../../Library/constants";
import { MODULE_TYPES, processReportData } from "../../../Library/widgets";

const labelData = [ "0-25%", "25-50%", "50-75%", "75-100%" ];
const parser = { x: "idx", y: "count", xLabel: "KMs", yLabel: "Throttle %" };
const paths = [
  { idx: 0, name: "Analytics", link: PATHS.ANALYTICS },
  { idx: 1, name: "Throttle Percentage", isCurrentPage: true },
];

const processData = (data, constants) => {
  const graphs = [];
  const legends = [];

  data.forEach((d) => {
    let counts = d.count.map(({ count }) => ((count || 0) / 1000).toFixed(2));

    graphs.push({
      color: constants.modelMap[d.model].color,
      model: constants.modelMap[d.model].nm,
      count: counts,
      modelId: d.model,
    });

    legends.push({ label: constants.modelMap[d.model].nm, color: constants.modelMap[d.model].color, modelId: d.model });
  });

  return { graphs, legends };
};

const ThrottleReport = () => {
  const { filters } = useContext(StoreContext);

  const reportRef = useRef(null);
  const widgetData = useRef(null);
  const reportData = useRef({});

  const [ isLoading, setIsLoading ] = useState(true);

  const handleFetchData = useCallback(async (filters, constants) => {
    setIsLoading(true);
    let categories = [];

    if (!widgetData.current) {
      // Used to Fetch Switcher Options
      const widgetData = await getWidgetData(DATE_RANGES[filters.range], [MODULE_TYPES.THROTTLE_PERCENT]);
      if (!widgetData) return;

      categories = widgetData[0].data;
      widgetData.current = categories;
      reportData.current = null;

      const response = await getStatsData(DATE_RANGES[filters.range], MODULE_TYPES.THROTTLE_PERCENT);
      const grouped = processReportData(response, "dst");   // Grouped Model-wise
      reportData.current = processData(grouped, constants);

      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (reportRef.current) reportRef.current.apply();
  }, [ handleFetchData ]);

  const getFilteredData = (data) => {
    const modelSet = new Set(filters.models);
    return data.filter((d) => modelSet.has(d.modelId));
  };

  return (
    <Report breadcrumb={paths} title={"Throttle Percentage"} isLoading={isLoading} onApply={handleFetchData} ref={reportRef}>
      {!isLoading && (
        <>
          <div className="panel-chart-switch">
            <div />
            <div />
          </div>

          <div className="panel-chart-header">
            <ChartLegend data={getFilteredData(reportData.current.legends)} />
            <ModelPicker />
          </div>

          <div className="panel-chart-main">
            <label className="panel-chart-label">
              Throttle %, vs KMs
            </label>

            <Stack data={getFilteredData(reportData.current.graphs)} labels={labelData} parser={parser} title="Throttle %" />
          </div>

          <div className="panel-chart-info" />
        </>
      )}
    </Report>
  );
}

export default ThrottleReport;
